import zh from '../../resources/locales/zh-CN.json';
import warehouse from './zh-CN/warehouse';
import aes from './zh-CN/aes';
export default {
  ...zh,
  ...warehouse,
  ...aes,
  ...JSON.parse(localStorage.getItem('overrides_translations') || '{}')['zh-CN'],
};
